import styled from 'styled-components'

import { Button } from '@/components'

export const HeroContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 160px;

  .words {
    display: flex;
    gap: 16px;
    margin-bottom: 80px;
  }

  @media (max-width: 1180px) {
    padding: 0 16px;
  }

  @media (max-width: 791px) {
    .words {
      gap: 8px;
      margin-bottom: 32px;
    }
  }
`

export const ButtonHero = styled(Button)``
